export const BRAZE_CONTENT_CARDS_REFRESH_INTERVAL = 1000 * 60 * 5;
